import React from "react";
import { Box, CircularProgress } from "@mui/material";
import { useSubscriptionAccessContext } from "../contexts/SubscriptionAccessContext";
import SubscriptionRequiredAlert from "./SubscriptionRequiredAlert";
import { useLocation } from "react-router-dom";
import { RouteTo } from "@routing/RouteMap";

interface Props {
  children: React.ReactNode;
  /** Optional: centers spinner vertically */
  fullHeight?: boolean;
}

/**
 * Höherwertige Komponente, die Child-Content nur dann rendert, wenn der Nutzer
 * ein aktives Abonnement besitzt. Andernfalls wird automatisch der
 * SubscriptionRequiredAlert angezeigt.
 */
const SubscriptionGate: React.FC<Props> = ({ children, fullHeight = false }) => {
  const { loading, hasAccess } = useSubscriptionAccessContext();
  const location = useLocation();
  const isOnboardingFlow = location.pathname.startsWith(RouteTo.ONBOARDING);

  // Während des Onboarding-Flows keine Zugangsbeschränkung oder Banner anzeigen
  if (isOnboardingFlow) {
    return <>{children}</>;
  }

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" py={6} height={fullHeight ? "100%" : undefined}>
        <CircularProgress />
      </Box>
    );
  }

  if (!hasAccess) {
    return <SubscriptionRequiredAlert gate />;
  }

  return <>{children}</>;
};

export default SubscriptionGate; 